import "virtual:uno.css";
import { createApp } from "vue";
import App from "./App.vue";

// 路由
import { setupRouter } from "./router";

// 引入element-plus
import { setupElementPlus } from "@/plugins/elementPlus";

// 引入状态管理
import { setupStore } from "@/store";

// 在src/main.js进行全局引入
import Vant from "vant";
import "vant/lib/index.css";

import "./permission";

// 自定义
import './styles/iconfont/iconfont.css'

const setupAll = async () => {
  const app = createApp(App);

  setupRouter(app);

  setupElementPlus(app);

  setupStore(app);

  app.use(Vant);

  app.mount("#app");
};

setupAll();
// console.log(window.history);

// window.addEventListener(
//   "popstate",
//   function (e) {
//     console.log(e);
//     // console.log();
//     alert(window.history.state.back);
//   },
//   false
// );
